(function () {
  var root = document.querySelector('[data-cg-arg]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';
  var D = root.dataset;
  var lg = (document.documentElement.lang || 'pt').toLowerCase().slice(0, 2);
  var L = window.CG_ARG_T && lg !== 'pt' ? window.CG_ARG_T[lg] : null;
  if (L) {
    Object.keys(L).forEach(function (k) {
      if (k in D) D[k] = L[k];
      root.querySelectorAll('[data-t="' + k + '"]').forEach(function (el) { el.textContent = L[k]; });
    });
  }
  var VS = '︎';
  var variants = JSON.parse(root.querySelector('[data-cg-arg-variants]').textContent || '[]');
  var corIdx = parseInt(D.cor, 10) || 0, maxc = parseInt(D.max, 10) || 14;
  var simbolos = (D.simbolos || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
  var optsHTML = root.querySelector('[data-cor-opts]').innerHTML;
  var rowsEl = root.querySelector('[data-rows]'), sameBox = root.querySelector('[data-same]'), sameSel = root.querySelector('[data-same-select]'), sameDot = root.querySelector('[data-same-dot]');
  var buy = root.querySelector('[data-buy]'), msg = root.querySelector('[data-msg]'), confirmEl = root.querySelector('[data-confirm]');
  var mode = 'each', fixed = {};
  var KEY = 'cg_arg_v1';
  function hasOpt(sel, v) { return Array.prototype.some.call(sel.options, function (o) { return o.value === v; }); }
  function save() {
    try { sessionStorage.setItem(KEY, JSON.stringify({ mode: mode, same: sameSel.value, rows: Array.prototype.map.call(rowsEl.children, function (li) { return { name: li.querySelector('input').value, cor: li.querySelector('select').value }; }) })); } catch (e) {}
  }
  var estilo = D.estilo || 'manual';
  var FOIL = [['dourad', '#d4ae52'], ['gold', '#d4ae52'], ['dorad', '#d4ae52'], ['dor', '#d4ae52'], ['prat', '#d3d3d8'], ['silver', '#d3d3d8'], ['plat', '#d3d3d8'], ['argent', '#d3d3d8'], ['silber', '#d3d3d8'], ['preto', '#1e1b1a'], ['rosa', '#c41f86'], ['azul', '#24399a'], ['verde', '#12784f'], ['branc', '#f4f1ea']];
  function foilHex() {
    for (var k in fixed) { var v = String(fixed[k]).toLowerCase(); for (var i = 0; i < FOIL.length; i++) { if (v.indexOf(FOIL[i][0]) === 0) return FOIL[i][1]; } }
    return '#d4ae52';
  }
  function light(h) { var n = parseInt(h.slice(1), 16), r = n >> 16, g = (n >> 8) & 255, b = n & 255; return (0.299 * r + 0.587 * g + 0.114 * b) > 150; }
  function paint(prev, name, cor) {
    var bg = hex(cor), t = prev.firstChild, lt = light(bg);
    prev.style.background = bg;
    t.textContent = name || D.nome;
    t.style.opacity = name ? '1' : '.45';
    t.className = 'cg-arg__pt cg-arg__pt--' + estilo;
    if (estilo === 'foil') { var f = foilHex(); t.style.color = f; t.style.textShadow = '0 1px 1px rgba(0,0,0,.35)'; }
    else { t.style.color = lt ? 'rgba(70,40,20,.6)' : 'rgba(0,0,0,.5)'; t.style.textShadow = lt ? '0 1px 0 rgba(255,255,255,.45)' : '0 1px 0 rgba(255,255,255,.16)'; }
  }
  var HEX = [['castanho escuro', '#4b3a31'], ['azul petr', '#2e5872'], ['azul-marinho', '#1f2d52'], ['azul escuro', '#1f2d52'], ['cinza', '#c2beb6'], ['natural', '#e6cfae'], ['camel', '#b27b4b'], ['mel', '#b27b4b'], ['castanho', '#6e4428'], ['vermelho', '#cf2236'], ['encarnado', '#cf2236'], ['bordeaux', '#5c1e2a'], ['azul', '#2c4a8a'], ['lavanda', '#bf9fe8'], ['preto', '#1c1c1f'], ['verde', '#3c5245'], ['azeitona', '#6c6a33'], ['turquesa', '#3aa19c'], ['laranja', '#c8642a'], ['amarelo', '#d9b23a'], ['rosa', '#c79bb5']];
  function hex(name) { var n = String(name || '').toLowerCase(); for (var i = 0; i < HEX.length; i++) { if (n.indexOf(HEX[i][0]) === 0) return HEX[i][1]; } return '#cdbfae'; }
  function len(s) { return Array.from(String(s).replace(/︎/g, '')).length; }
  function clip(s) { var out = '', n = 0; Array.from(String(s)).forEach(function (ch) { if (ch === VS) { out += ch; return; } if (n < maxc) { out += ch; n++; } }); return out; }
  var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR', loc = document.documentElement.lang || 'pt-PT';
  function money(c) { try { return new Intl.NumberFormat(loc, { style: 'currency', currency: cur }).format(c / 100); } catch (e) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; } }
  function findVariant(cor) {
    for (var i = 0; i < variants.length; i++) { var v = variants[i], ok = v.options[corIdx] === cor; for (var k in fixed) { if (v.options[k] !== fixed[k]) ok = false; } if (ok) return v; }
    return null;
  }
  root.querySelectorAll('[data-opt]').forEach(function (box) {
    var idx = parseInt(box.dataset.opt, 10), first = box.querySelector('.cg-arg__pill');
    if (first) fixed[idx] = first.dataset.val;
    box.addEventListener('click', function (e) {
      var b = e.target.closest('.cg-arg__pill'); if (!b) return;
      box.querySelectorAll('.cg-arg__pill').forEach(function (x) { x.classList.remove('is-on'); x.setAttribute('aria-pressed', 'false'); });
      b.classList.add('is-on'); b.setAttribute('aria-pressed', 'true'); fixed[idx] = b.dataset.val; update();
    });
  });
  function addRow(name, cor) {
    var li = document.createElement('li'); li.className = 'cg-arg__row';
    var simHTML = '';
    if (simbolos.length) {
      simHTML = '<button type="button" class="cg-arg__sym" aria-expanded="false">' + D.simbLabel + '</button>' +
        '<div class="cg-arg__syms" hidden>' + simbolos.map(function (s) { return '<button type="button" class="cg-arg__s" data-s="' + s + '">' + s + VS + '</button>'; }).join('') + '</div>';
    }
    li.innerHTML = '<span class="cg-arg__n"></span><span class="cg-arg__dot" aria-hidden="true"></span><input type="text" class="cg-arg__name" autocomplete="off"><select class="cg-arg__select">' + optsHTML + '</select><span class="cg-arg__chars"></span><button type="button" class="cg-arg__x">×</button><div class="cg-arg__prev" aria-hidden="true"><span class="cg-arg__pt"></span></div>' + simHTML;
    var inp = li.querySelector('input'), sel = li.querySelector('select');
    inp.placeholder = D.ph || D.nome; inp.value = clip(name || '');
    if (cor && hasOpt(sel, cor)) sel.value = cor; else if (rowsEl.lastElementChild) sel.value = rowsEl.lastElementChild.querySelector('select').value;
    inp.addEventListener('input', function () { var c = clip(inp.value); if (c !== inp.value) inp.value = c; update(); });
    sel.addEventListener('change', update);
    li.querySelector('.cg-arg__x').addEventListener('click', function () { if (rowsEl.children.length > 1) li.remove(); else inp.value = ''; update(); });
    var symBtn = li.querySelector('.cg-arg__sym'), symBox = li.querySelector('.cg-arg__syms');
    if (symBtn) {
      symBtn.addEventListener('click', function () { var open = symBox.hidden; symBox.hidden = !open; symBtn.setAttribute('aria-expanded', open ? 'true' : 'false'); });
      symBox.addEventListener('click', function (e) {
        var b = e.target.closest('.cg-arg__s'); if (!b) return;
        if (len(inp.value) >= maxc) { msg.textContent = D.cheio; return; }
        var s = b.dataset.s + VS, v = inp.value;
        var a = inp.selectionStart != null ? inp.selectionStart : v.length, z = inp.selectionEnd != null ? inp.selectionEnd : v.length;
        var left = v.slice(0, a), right = v.slice(z);
        if (left && !/\s$/.test(left)) s = ' ' + s;
        if (right && !/^\s/.test(right)) s = s + ' ';
        inp.value = clip(left + s + right);
        var pos = Math.min(inp.value.length, (left + s).length);
        try { inp.setSelectionRange(pos, pos); } catch (err) {}
        update();
      });
    }
    rowsEl.appendChild(li);
  }
  function rows() { return Array.prototype.map.call(rowsEl.children, function (li) { return { li: li, name: li.querySelector('input').value.trim(), cor: mode === 'same' ? sameSel.value : li.querySelector('select').value }; }); }
  function update() {
    var list = rows(), total = 0, missing = [], bad = [];
    list.forEach(function (r, i) {
      var li = r.li, n = i + 1, sel = li.querySelector('select'), inp = li.querySelector('input');
      li.querySelector('.cg-arg__n').textContent = n;
      li.querySelector('.cg-arg__dot').style.background = hex(r.cor);
      sel.hidden = mode === 'same'; sel.setAttribute('aria-label', D.nome + ' ' + n + ' · ' + (D.corRow || 'cor'));
      inp.setAttribute('aria-label', D.nome + ' ' + n);
      li.querySelector('.cg-arg__x').setAttribute('aria-label', D.remover + ' ' + n);
      li.querySelector('.cg-arg__chars').textContent = maxc > 1 ? len(inp.value) + '/' + maxc : '';
      paint(li.querySelector('.cg-arg__prev'), inp.value.trim(), r.cor);
      var v = findVariant(r.cor);
      if (!v || !v.available) bad.push(n + ' (' + r.cor + ')'); else total += v.price;
      if (!r.name.replace(/︎/g, '').trim()) missing.push(n);
    });
    sameDot.style.background = hex(sameSel.value);
    var q = list.length, label = q + ' ' + (q === 1 ? D.un : D.pl), v0 = findVariant(list[0] ? list[0].cor : sameSel.value);
    root.querySelector('[data-count]').textContent = v0 ? label + ' · ' + money(v0.price) + ' ' + D.cada : label;
    root.querySelector('[data-qtylabel]').textContent = label;
    root.querySelector('[data-total]').textContent = money(total);
    var hint = '';
    if (bad.length) hint = D.indisp + ' ' + bad.join(', ');
    else if (missing.length === 1) hint = D.falta + ' ' + missing[0] + '.';
    else if (missing.length > 1) hint = D.faltam + ' ' + missing.join(', ') + '.';
    else if (!confirmEl.checked) hint = D.conf;
    var neutral = !bad.length && !list.some(function (r) { return r.name; });
    if (neutral) hint = D.inicio;
    msg.classList.toggle('is-neutral', neutral);
    buy.disabled = !!hint; msg.textContent = hint;
    save();
  }
  root.querySelectorAll('[data-mode]').forEach(function (b) {
    b.addEventListener('click', function () {
      mode = b.dataset.mode;
      root.querySelectorAll('[data-mode]').forEach(function (x) { var on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      sameBox.hidden = mode !== 'same'; update();
    });
  });
  sameSel.addEventListener('change', update); confirmEl.addEventListener('change', update);
  root.querySelector('[data-add]').addEventListener('click', function () { addRow('', ''); update(); rowsEl.lastElementChild.querySelector('input').focus(); });
  var paste = root.querySelector('[data-paste]'), pasteBtn = root.querySelector('[data-paste-btn]');
  if (paste && pasteBtn) {
    var names = function () { return paste.value.split('\n').map(function (t) { return t.trim(); }).filter(Boolean); };
    paste.addEventListener('input', function () { var n = names().length; pasteBtn.textContent = n ? D.addn.replace('[n]', n) : D.colarBtn; });
    pasteBtn.addEventListener('click', function () {
      var list = names(); if (!list.length) return;
      Array.prototype.slice.call(rowsEl.children).forEach(function (li) { if (!li.querySelector('input').value.trim() && rowsEl.children.length > 1) li.remove(); });
      var only = rowsEl.children.length === 1 && !rowsEl.firstElementChild.querySelector('input').value.trim();
      list.forEach(function (n, i) { if (i === 0 && only) rowsEl.firstElementChild.querySelector('input').value = clip(n); else addRow(n, ''); });
      paste.value = ''; pasteBtn.textContent = D.colarBtn; update();
    });
  }
  buy.addEventListener('click', function () {
    if (buy.disabled) return;
    var items = rows().map(function (r) { return { id: findVariant(r.cor).id, quantity: 1, properties: { 'Nome': r.name.replace(/︎/g, '') } }; });
    buy.disabled = true;
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(base + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
      .then(function () { try { sessionStorage.removeItem(KEY); } catch (e) {} window.location.href = base + 'cart'; })
      .catch(function () { msg.textContent = D.erro; buy.disabled = false; });
  });
  var saved = null;
  try { saved = JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) {}
  if (saved && saved.rows && saved.rows.length) {
    saved.rows.forEach(function (r) { addRow(r.name, r.cor); });
    if (saved.same && hasOpt(sameSel, saved.same)) sameSel.value = saved.same;
    if (saved.mode === 'same') root.querySelector('[data-mode="same"]').click();
  } else addRow('', '');
  update(); root.hidden = false;
  var scope = root.parentElement;
  while (scope && scope !== document.body && !scope.querySelector('variant-picker, form[action*="/cart/add"]')) scope = scope.parentElement;
  if (scope && scope !== document.body) {
    scope.querySelectorAll('variant-picker, product-form-component, form[action*="/cart/add"]').forEach(function (el) { if (!root.contains(el)) el.classList.add('cg-arg-hide'); });
    scope.querySelectorAll('.shopify-app-block, [id*="globo" i], [class*="globo" i]').forEach(function (el) {
      if (root.contains(el) || el.contains(root)) return;
      if (/globo/i.test(el.id + ' ' + el.className + ' ' + (el.getAttribute('data-block-handle') || ''))) el.classList.add('cg-arg-hide');
    });
  }
  document.querySelectorAll('sticky-add-to-cart, .sticky-add-to-cart').forEach(function (el) { el.classList.add('cg-arg-hide'); });
})();